// CZK number formatting (e.g. 4 500 000 Kč)
export const formatCZK = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "0 Kč";
  const rounded = Math.round(Number(value));
  return new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: "CZK",
    maximumFractionDigits: 0,
  }).format(rounded);
};

// Plain integer with cs-CZ thousands spacing (no currency symbol)
export const formatNumCZ = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "0";
  return new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 0 }).format(
    Math.round(Number(value))
  );
};
